import { ActionIcon, Tooltip, Text } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import { useMainRoutePath } from 'utils/location';
import { showClass } from 'utils/helpers';
import { NavLinkItem } from 'utils/navbar';
import { useAppContext } from 'context/hooks';
import { useTranslation } from 'react-i18next';
import classes from './NavBar.module.css';

interface NavLinkProps {
  item: NavLinkItem;
  small?: boolean;
  testId: string;
}
export const NavLink = ({ item, small, testId }: NavLinkProps) => {
  const { t } = useTranslation();
  const { isNavBarCollapsed } = useAppContext();
  const location = useLocation();
  const currentRoutePath = useMainRoutePath();

  const isActiveLink = item.link === currentRoutePath;
  const locationLevel = location.pathname.split('/').length - 1;

  const text = t(item.label);

  return (
    <Tooltip label={text} position={'right'} disabled={!isNavBarCollapsed}>
      <Link
        className={`${classes.link} ${showClass(classes.bigLink, !small)} ${showClass(classes.activeLink, isActiveLink)}`}
        key={item.label}
        to={item.link}
        target={small ? '_blank' : undefined}
        onClick={(e) => isActiveLink && locationLevel <= 1 && e.preventDefault()}
        data-testid={`nav-link-${testId}`}
      >
        <ActionIcon
          variant={'transparent'}
          c={isActiveLink ? 'var(--mantine-color-turquoise-5)' : 'var(--mantine-color-white)'}
        >
          {item.leftIcon}
        </ActionIcon>

        {!isNavBarCollapsed && (
          <Text
            fz={'sm'}
            c={isActiveLink ? 'var(--mantine-color-turquoise-5)' : 'var(--mantine-color-white)'}
            fw={isActiveLink ? 'bold' : '500'}
            ml={'sm'}
          >
            {text}
          </Text>
        )}
      </Link>
    </Tooltip>
  );
};
